import script from "./newsDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./newsDetail.vue?vue&type=script&setup=true&lang=js"

import "./news.css?vue&type=style&index=0&id=54077369&scoped=true&lang=css"

import exportComponent from "D:\\work\\gw-sh\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54077369"]])

export default __exports__